import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import strings from 'strings';
import FPIconButton from 'UI/components/atoms/FPIconButton';
import { BULK_METRIC_STATUSES } from 'UI/constants/defaults';
import { SvgArrowRight } from 'UI/res';
import { objectToArray } from 'UI/utils';

import { useStyles } from './styles';

const { cards: cardsCopies } = strings.bulkEmails.stats;

const STATS_KEYS = {
  automaticReply: 'automatic_reply_emails',
  bounced: 'bounced_emails',
  click: 'click_emails',
  dropped: 'dropped_emails',
  fixable: 'fixable_emails',
  open: 'open_emails',
  originalMeantRecipients: 'original_meant_recipients',
  pending: 'pending_emails',
  quotaExceeded: 'quota_exceeded_emails',
  reply: 'reply_emails',
  sent: 'sent_emails',
  spam: 'spam_emails',
  unreachable: 'unreachable_emails',
  unsubscribe: 'unsubscribe_emails'
};

/**
 * @param {number} count
 * @returns {string}
 */
export const getItemLabel = count => {
  if (count === 0) return '- -';
  return count < 10 && count > 0 ? count.toString().padStart(2, '0') : count.toString();
};

const BulkStatsInfoCard = ({ onShowStatsDetail = null, stats }) => {
  const classes = useStyles();
  const statsCards = [
    {
      key: STATS_KEYS.pending,
      order: 0,
      status: BULK_METRIC_STATUSES.pending,
      shouldShow: stats[STATS_KEYS.pending] > 0
    },
    {
      key: STATS_KEYS.quotaExceeded,
      order: 1,
      status: BULK_METRIC_STATUSES.quotaExceeded,
      shouldShow: stats[STATS_KEYS.quotaExceeded] > 0
    },
    { key: STATS_KEYS.sent, order: 2, status: BULK_METRIC_STATUSES.delivered },
    { key: STATS_KEYS.open, isSubItem: true, order: 2.1, status: BULK_METRIC_STATUSES.open },
    { key: STATS_KEYS.spam, isSubItem: true, order: 2.4, status: BULK_METRIC_STATUSES.spam },
    { key: STATS_KEYS.click, isSubItem: true, order: 2.5, status: BULK_METRIC_STATUSES.click },
    {
      key: STATS_KEYS.reply,
      isSubItem: true,
      order: 2.2,
      status: BULK_METRIC_STATUSES.reply
    },
    {
      key: STATS_KEYS.automaticReply,
      isSubItem: true,
      order: 2.3,
      status: BULK_METRIC_STATUSES.automaticReply
    },
    { key: STATS_KEYS.bounced, order: 10, status: BULK_METRIC_STATUSES.bounce },
    { key: STATS_KEYS.unreachable, order: 10, status: BULK_METRIC_STATUSES.unreachable },
    { key: STATS_KEYS.dropped, order: 10, status: BULK_METRIC_STATUSES.dropped },
    { key: STATS_KEYS.fixable, order: 10, status: BULK_METRIC_STATUSES.fixable },
    { key: STATS_KEYS.unsubscribe, order: 10, status: BULK_METRIC_STATUSES.unsubscribe },
    {
      key: STATS_KEYS.originalMeantRecipients,
      order: 10,
      status: objectToArray(BULK_METRIC_STATUSES).join(',')
    }
  ];
  const filteredStats =
    stats &&
    statsCards.filter(({ key, shouldShow }) => {
      if (!Object.keys(stats).includes(key)) return false;
      return typeof shouldShow !== 'undefined' ? shouldShow : true;
    });

  const orderedStatsCards = filteredStats.sort((a, b) => a.order - b.order);

  const handleCardClick =
    ({ title, status }) =>
    () =>
      onShowStatsDetail && onShowStatsDetail({ title, status });

  return stats ? (
    <Grid container direction="column">
      {orderedStatsCards.map(({ key, isSubItem, status }) => (
        <Grid
          key={key}
          item
          data-testid="bulk-stat-card"
          container
          className={clsx(
            classes.cardItem,
            isSubItem ? classes.subItemSpacing : classes.cardItemSpacing
          )}
          alignItems="center"
          onClick={handleCardClick({ title: cardsCopies[key].title, status })}
        >
          <Grid container item xs={8} direction="column">
            <Typography variant="h5">{cardsCopies[key].title}</Typography>
            <Typography variant="body2" className={classes.description}>
              {cardsCopies[key].description}
            </Typography>
          </Grid>
          <Grid container item xs={4} alignItems="center" justify="flex-end">
            <Typography className={classes.totalItems}>{getItemLabel(stats[key])}</Typography>
            <FPIconButton tooltipProps={{ title: cardsCopies.viewDetails }} icon={SvgArrowRight} />
          </Grid>
        </Grid>
      ))}
    </Grid>
  ) : null;
};

export default BulkStatsInfoCard;
